import { render, staticRenderFns } from "./Autoresponders.vue?vue&type=template&id=5193d178&"
import script from "./Autoresponders.vue?vue&type=script&lang=js&"
export * from "./Autoresponders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5193d178')) {
      api.createRecord('5193d178', component.options)
    } else {
      api.reload('5193d178', component.options)
    }
    module.hot.accept("./Autoresponders.vue?vue&type=template&id=5193d178&", function () {
      api.rerender('5193d178', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Services/Hosting/Shared/Email/Autoresponders/Autoresponders.vue"
export default component.exports